module.exports = {
    Description: {
        StaticInfo: `
        <p>
            The work carried out intended to obtain an initial hydrocarbon production rate, an anticipated decline and
            therefore the production in time of a predicted volume of reserves. The purpose of this analysis is to evaluate
            the results of the operation.
        </p>
        `,
        SectionsInfo: []
    },
    Overview: {
        StaticInfo: "",
        SectionsInfo: [{
                title: "The diagnostics of the results of the operation answers the following questions",
                content: `
                <ul>
                <li>Was the anticipated initial production rate achieved?</li>
                <li>Are the initial decline and water cuts behaving as expected?</li>
                <li>Was the operation carried-out according to plan?</li>
                <li>Were the final costs and execution time according to plan?</li>
                </ul>
                <br>
                <p>
                If any of the answers is negative, it is necessary to identify the reason(s) for these results and determine if there are any corrective measures that can be taken.</p>
                The rate assessment must be maintained long enough to conclude whether the anticipated decline is being
                achieved. This can vary in each case.</p>
                If not, it must be concluded which of the elements has not resulted as expected in the design of the operation
                (length or width of fractures, support agent, placement of the same, closure of fractures, water invasion,
                costs, execution times and others).</p>
                <p>Only the rate-time combination generates the long-term production of the forecasted reserves. As the diagnostics
                must be carried-out in the first days and months after the execution of the Procedure, the forecasted long range
                reserve volume is the <strong>least firm element of the diagnostics</strong>, although the early evaluation of the decline
                practically sets the course for the diagnostics results.
                </p>
                `
            },
            {
                title: "Flowback and Early-Time Production Data Analysis",
                content: `<p>
                A meaningful analysis of online production typically requires 6 to 12 months of data, which does not allow the
                operator to make adjustments to their stimulation treatments during an annual drilling program. This has led
                researchers to investigate the use of flow rates and pressures obtained during the flowback period (i.e.,
                early-time production data obtained immediately after the well has been hydraulically fractured). During this
                early period, flow to the well is expected to be dominated by flow in the fractures, whereas reservoir flow
                dominates during online production.<br>
                <br>
                Historically, Rate-transient analysis (RTA) focuses on online production data (i.e., production after the well is
                tied in to surface facilities). However, as with PTA (pressure transient analysis), particularly at early
                production times, it is often difficult to separately determine reservoir and hydraulic fracture properties in
                the analysis.<br>
                <br>
                RTA methods can be combined with flowing pressures to extract reservoir and/or hydraulic fracture properties and
                fluid in place, analogous to pressure-transient analysis (PTA). These methods applied to online production for
                analyzing reservoir behavior might be adapted and modified to analyze fracture behavior during flowback, in
                which the fracture is the primary porous medium being analyzed as opposed to the reservoir during online
                production.<br>
                <br>
                </p>
                `
            },
            {
                title: "The basic steps to analyze the data includes",
                content: `
                <ul>
                <li>Step 1: Assess data viability</li>
                <li>Step 2: Check for datacorrelation</li>
                <li>Step 3: Filter and edit data</li>
                <li>Step 4: Identify flow regimes</li>
                <li>Step 5: Perform straight-line analysis</li>
                <li>Step 6: Perform Type-Curve Analysis (TCA)</li>
                <li>Step 7: Perform history match with model</li>
                <li>Step 8: Compare flowback and online results</li>
                </ul>
                <br>
                <p>
                The analysis of a (DFIT) diagnostic fracture injection test together with PTA and RTA analysis could help to:</p>
                <ul>
                <li>Fracture closure analysis</li>
                <li>Fracture closure dynamics</li>
                <li>Pseudo-radial flow analysis</li>
                <li>Pseudo-linear flow analysis</li>
                <li>Injection rate</li>
                <li>Wellbore storage</li>
                <li>Treatment size and fracture length</li>
                <li>Mobility</li>
                <li>Test results</li>
                </ul>
                <br>
                <p>
                The figure shows a typical sequence of operations undertaken during the lifetime of a hydraulic fracturing job completed in a tight reservoir:
                </p>
                <div style="width:100%;">
    <img style="width:100%;" src='https://firebasestorage.googleapis.com/v0/b/practica-9c4fb.appspot.com/o/4_1_Results_diagnostics.jpg?alt=media&token=ef781a21-94a0-4a47-a508-8759837e6337' />
    </div>
                `
            }
        ]
    },
    Inputs: {
        StaticInfo: `
        <p>
        In this section our purpose is help you with an objective operation´s results diagnostics. Please consider uploading the operation´s results provided by the service company and other relevant data for analysis.
        </p>
        `,
        SectionsInfo: []
    },
    Deliverables: {
        StaticInfo: `
        <p>
       In this section the EGEP consultant will review and discuss his or her conclusions about the results obtained from the operation, and provide a report with analysis, conclusions and recommendations.
        </p>
        `,
        SectionsInfo: []
    }
}